export default "__VITE_ASSET__DGSaDLJ3__"